export default __webpack_public_path__ + "static/media/banner-background.968137c0.svg";